import React, { Component } from "react";
import Header from './Header'
import {getBenchmarkData, getTowers} from '../services/BinderDropService'
import { Doughnut, defaults, Bar } from 'react-chartjs-2';
import {AddRecent, ShrinkNumber} from '../util/Helper'
import InfoCard from "../components/InfoCard";
import BenchmarkRow from "../components/BenchmarkRow";
import Selector from '../components/Selector';

import CONSTANTS from "../util/Constants";
import ImageOrInitial from "../components/ImageOrInitial";

const queryString = require('query-string');


class Benchmarking extends Component {
  constructor(props) {
    super(props);
    const _params = queryString.parse(this.props.location.search);

    this.state = {
      minMarketCap:_params.mincap || null,
      maxMarketCap:_params.maxcap || null,
      sector:_params.sector || 'Any',
      companyId:_params.companyId,
    };
    //document.title = "Home"

    
}

componentDidMount() {
  if(this.state.minMarketCap || this.state.minMarketCap || this.state.sector !== 'Any'){
    this.runBenchmark();
  }
}

runBenchmark = () =>{
  console.log("runBenchmark");
  getBenchmarkData(this.state.sector === "Any" ? null : this.state.sector, this.state.minMarketCap, this.state.maxMarketCap).then((data) => {

      if(this.state.companyId){
        getTowers(this.state.companyId, null, null).then((towers) => {
          if(towers && towers.length > 0){
            data?.rows?.forEach(r => {
              if(r.title === "Total Limit"){
                r.value = towers[0].totalLimit;
              }
              if(r.title === "Total Pricing"){
                r.value = towers[0].premiumPerMillion;
              }        
              if(r.title === "Side-A Limits"){
                r.value = towers[0].sideALimit;
              }  
              if(r.title === "Retentions"){
                r.value = towers[0].totalRetention;
              }         
            });

            this.setState({tower:towers[0], data, refreshTimeStamp:new Date()});
          }
        });
      }
      else {
        this.setState({data});
      }
    
    

    
  });
}


  render() {
    return (
      <div>
        <Header title="Benchmarking"/>
        {this.state.tower &&
          <div className="headerEntity card">
            <ImageOrInitial image={this.state.tower.company?.imageUrl} className="heImage" name={this.state.tower.company?.name} />
            <span  className="heName">{this.state.tower.company?.name}</span>
          </div>
        }
        <div className="card filterContainer">
        <div className="cardRow">
          <span className="fieldDescription">Sector</span>
          <span className="fieldDescription">Market Cap Range</span>
          <span className="fieldDescription"></span>
          <span className="fieldDescription"></span>
        </div>
        <div className="cardRow" style={{paddingTop: "0px", marginTop:"-10px"}}>
          <Selector onChange={(value) => {this.setState({sector:value})}} defaultValue={this.state.sector} options={['Any', 'Miscellaneous', 'Consumer Discretionary', 'Utilities', 'Telecommunications', 'Real Estate', 'Energy', 'Finance', 'Health Care', 'Basic Materials', 'Industrials', 'Technology']}/>
          <div  className="fieldInputOutter">
            <input type="text" placeholder="Min" className="fieldInput" value={ this.state.minMarketCap } onChange={(e) => this.setState({minMarketCap:e.target.value})}/>
            {this.state.minMarketCap > 1000 &&
            <span className="fieldInputPreview">${ShrinkNumber(this.state.minMarketCap)}</span>
            }
          </div>
          <div  className="fieldInputOutter">
            <input type="text" placeholder="Max" className="fieldInput" value={ this.state.maxMarketCap } onChange={(e) => this.setState({maxMarketCap:e.target.value})}/>
            {this.state.maxMarketCap > 1000 &&
            <span className="fieldInputPreview">${ShrinkNumber(this.state.maxMarketCap)}</span>
            }
          </div>
          <button className='pillButton' style={{width:"100%"}}  onClick={this.runBenchmark}>Run</button>
        </div>
        </div>
        

        {this.state.data &&
        <>
          <label className="sectionTitle">Results</label>
          <div className="cardRow" style={{marginBottom:"10px"}}>
            <InfoCard title="Number of Peers" value={this.state.data.peerCount}/>
            <InfoCard title="Percent Buy Side-A" value={Math.round(this.state.data.sideAPercentage)+"%"}/>
            <InfoCard title="Average Total Limits" value={"$"+ShrinkNumber(this.state.data.averageTotalLimit)}/>
          </div>

          <div className="card fullTable">
                  
          {this.state.data.rows?.map((row, index) => {
            return <BenchmarkRow row={row} refreshTimeStamp={this.state.refreshTimeStamp}/>
          })}

          </div>
        </>
        }
        

        
        
      </div>
      
    );
  }
}
 
export default Benchmarking;